module.exports = __webpack_public_path__ + "mo/img/piece-23.7ba36c55.svg";